import { render, staticRenderFns } from "./RecomendationPill.vue?vue&type=template&id=f64dffb2&"
import script from "./RecomendationPill.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RecomendationPill.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports